import styled from "styled-components";

export const ChartWrapper = styled.div`
    color: white !important;
`;
